(() => {

    const KEYWORDS = [
        "Beads?",
        "Bracelets?",
        "Necklace?",
        "Gemstones?",
        "Pearls?",
        "DIY Kits?",
        "Findings & Parts?",
        "Charms & Pendants?",
        "Jewellery Tools?"
    ];

    const INTERVAL = 2000;
    const DURATION = 350;

    function init(input) {

        const parent = input.parentElement;

        if (!parent || parent.querySelector(".ankur-search-placeholder")) return;

        parent.style.position = "relative";

        input.setAttribute("placeholder", "");

        const placeholder = document.createElement("div");
        placeholder.className = "ankur-search-placeholder";

        placeholder.innerHTML = `
            <span class="ankur-search-fixed">Looking for&nbsp;</span>
            <span class="ankur-search-keyword-wrapper">
                <span class="ankur-search-keyword">${KEYWORDS[0]}</span>
            </span>
        `;

        parent.appendChild(placeholder);

        // Match overlay typography with input
        const inputStyles = window.getComputedStyle(input);

        placeholder.style.font = inputStyles.font;
        placeholder.style.fontFamily = inputStyles.fontFamily;
        placeholder.style.fontSize = inputStyles.fontSize;
        placeholder.style.fontWeight = inputStyles.fontWeight;
        placeholder.style.fontStyle = inputStyles.fontStyle;
        placeholder.style.lineHeight = inputStyles.lineHeight;
        placeholder.style.letterSpacing = inputStyles.letterSpacing;
        placeholder.style.textTransform = inputStyles.textTransform;
        placeholder.style.color = inputStyles.color;

        const keyword = placeholder.querySelector(".ankur-search-keyword");
        const keywordWrapper = placeholder.querySelector(".ankur-search-keyword-wrapper");
        const fixedText = placeholder.querySelector(".ankur-search-fixed");

        // Calculate padding needed so typing starts after "Looking for "
        const originalPaddingLeft = parseFloat(inputStyles.paddingLeft) || 15;
        const prefixWidth = fixedText.offsetWidth;
        const typingPadding = originalPaddingLeft + prefixWidth;

        let index = 0;
        let timer = null;
        let paused = false;

        function nextKeyword() {

            if (paused) return;

            keyword.classList.add("slide-up");

            setTimeout(() => {

                index = (index + 1) % KEYWORDS.length;

                keyword.classList.remove("slide-up");
                keyword.classList.add("slide-down");

                keyword.textContent = KEYWORDS[index];

                requestAnimationFrame(() => {
                    keyword.classList.remove("slide-down");
                });

            }, DURATION);

        }

        function start() {

            stop();

            timer = setInterval(nextKeyword, INTERVAL);

        }

        function stop() {

            if (timer) {
                clearInterval(timer);
                timer = null;
            }

        }

        function showKeyword() {

            keywordWrapper.classList.remove("hidden");
            input.style.paddingLeft = "";
        }

        function hideKeyword() {

            keywordWrapper.classList.add("hidden");
            input.style.paddingLeft = `${typingPadding}px`;
        }

        // Focus
        input.addEventListener("focus", () => {

            paused = true;
            stop();

            hideKeyword();

        });

        // Blur
        input.addEventListener("blur", () => {

            if (input.value.trim() === "") {

                showKeyword();

                paused = false;
                start();

            }

        });

        // Typing
        input.addEventListener("input", () => {

            if (input.value.trim().length > 0) {

                hideKeyword();

                paused = true;
                stop();

            } else {

                showKeyword();

                paused = false;
                start();

            }

        });

        start();

    }

    function boot() {

        document
            .querySelectorAll(".header-search__input")
            .forEach(init);

    }

    if (document.readyState === "loading") {

        document.addEventListener("DOMContentLoaded", boot);

    } else {

        boot();

    }

})();